import React from "react";
import { Form, Card } from "react-bootstrap";
import Button from "../components/Button";
import styles from "./UsersList.module.scss"; // importa o módulo de estilos
import UserCard from "./UserCard";

interface UsersListProps {
  users: User[];
  onUserClick?: (user: User) => void;
  onAddUserClick?: () => void;
  onQueryChange?: (query: string) => void; // <- aqui
  mode?: 'paciente' | 'usuário';
}


export default function UsersList({ users, onUserClick, onQueryChange, onAddUserClick, mode = 'usuário' }: UsersListProps) {
  const [query, setQuery] = React.useState<string>("");
  
  return (
    <Card className={styles.card}>
      <Card.Header className={styles.cardHeader}>
        <Card.Title className={styles.cardTitle}><span>{mode.charAt(0).toUpperCase() + mode.slice(1)}s</span></Card.Title>
      </Card.Header>
      <Card.Body className={styles.cardBody}>
          <Button
            label={"Adicionar " + mode}
            onClick={onAddUserClick}
          />
          <Form.Control
            type="text"
            placeholder={"Busque pelo nome do " + mode}
            className={styles['input-control']}
            value={query}
            onChange={(e) => {
              const newQuery = e.target.value;
              setQuery(newQuery);
              onQueryChange?.(newQuery); // <- chama o pai
            }}
          />
          <div>
            {users.map((user) => (
              <UserCard
                user={user}
                mode={mode}
                onUserClick={() => onUserClick?.(user)}
              />
            ))}
          </div>
      </Card.Body>
    </Card>
  );
}
